import Icon from '@/components/snippets/icon/icon'

/**
 * Accordion wrapper for one facet.
 * @param {string} label - Facet label
 * @param {string|number} [activeFilterLabel] - Applied range or checked count, shown beside the label
 * @param {'number'} [valueType] - `'number'` renders the label as a bracketed count
 */
export function FilterCollapse({ label, activeFilterLabel, valueType, children }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  const activeLabel = activeFilterLabel
    ? valueType === 'number'
      ? `(${activeFilterLabel})`
      : activeFilterLabel
    : null
  return (
    <x-modal
      data-id={`filter-${id}`}
      data-toggle-group="true"
      className="group/filter dropdown-modal flex flex-col border-b border-borders-default"
    >
      <button
        className="flex items-center justify-between gap-x-0.75 min-h-[65px] px-margin py-1.5 text-left link-fade text-type-black-primary"
        data-modal-parent={`filter-${id}`}
        data-modal-role="toggle"
        aria-label={activeLabel ? `${label} ${activeLabel}` : label}
      >
        <span className="flex min-w-0 items-center gap-x-0.5">
          <span className="heading-xs">{label}</span>
          {activeLabel && <span className="heading-xs text-type-black-secondary">{activeLabel}</span>}
        </span>
        <div className={'flex size-[14px] group-data-visible/filter:-rotate-180 transition-all children:size-full'}>
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 overflow-hidden">{children}</div>
      </div>
    </x-modal>
  )
}
